import { PureComponent } from 'react'
import _ from 'lodash'
import { Pagination } from 'antd'
import styles from './BestsellerPagination.css'

class BestsellerPagination extends PureComponent {
  // antd pagination 不支援點擊取得事件，因此點擊加在外層透過事件冒泡判斷點擊分頁
  handlePaginationClick = e => {
    const { onPaginationClick } = this.props
    const currentEle = _.get(e, 'target.nodeName')
    if (currentEle === 'A') {
      onPaginationClick && onPaginationClick(e)
    }
  }

  render () {
    const { onPaginationClick, ...restProps } = this.props
    return (
      <section
        onClick={this.handlePaginationClick}
        className={styles.BestsellerPagination}
      >
        <Pagination
          showSizeChanger={false}
          {...restProps}
        />
      </section>
    )
  }
}

export default BestsellerPagination
